import type { Line, Script } from './domain.js';

/** Speaking rate for estimates before a take exists (words per second). */
export const WORDS_PER_SECOND = 2.5;
export const MIN_LINE_SECONDS = 2;

export function countWords(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length;
}

export function estimateLineSeconds(line: Pick<Line, 'text'>): number {
  return Math.max(MIN_LINE_SECONDS, Math.round((countWords(line.text) / WORDS_PER_SECOND) * 10) / 10);
}

export interface LineTiming {
  lineId: string;
  start: number;
  end: number;
}

/** Estimated start and end (seconds) of every line, back to back. */
export function estimateTimeline(script: Pick<Script, 'lines'>): LineTiming[] {
  let t = 0;
  return script.lines.map((line) => {
    const d = estimateLineSeconds(line);
    const timing = { lineId: line.id, start: round1(t), end: round1(t + d) };
    t += d;
    return timing;
  });
}

export function estimateRuntime(script: Pick<Script, 'lines'>): number {
  const tl = estimateTimeline(script);
  return tl.length ? tl[tl.length - 1]!.end : 0;
}

export function formatRange(t: LineTiming): string {
  return `${Math.round(t.start)}–${Math.round(t.end)} s`;
}

function round1(n: number): number {
  return Math.round(n * 10) / 10;
}
